<div class="flex flex-col h-full">
  <!-- Waiting for the server -->
  <div *ngIf="!isPageReady" class="flex flex-col flex-1 gap-3 items-center justify-center">
    <p-progressSpinner ariaLabel="loading" strokeWidth="4" [style]="{ width: '44px', height: '44px' }"></p-progressSpinner>
    <span class="text-sm" style="color: var(--p-text-muted-color)">The system looks for the late job orders.</span>
  </div>

  <ng-container *ngIf="isPageReady">
    <!-- Sort and List-Size Selectors -->
    <div class="flex gap-2 p-2 border-b shrink-0">
      <div class="flex-1 min-w-0">
        <p-dropdown
          [options]="sortOptions"
          [(ngModel)]="sortKey"
          optionLabel="label"
          optionValue="value"
          (onChange)="onSortChange()"
          styleClass="w-full"
        ></p-dropdown>
      </div>
      <div class="w-28 shrink-0">
        <p-dropdown
          [options]="accountCountOptions"
          [(ngModel)]="accountCount"
          optionLabel="label"
          optionValue="value"
          (onChange)="onAccountCountChange()"
          styleClass="w-full"
        ></p-dropdown>
      </div>
    </div>

    <!-- Column Headers -->
    <div *ngIf="rows.length > 0"
         class="grid grid-cols-12 gap-2 px-3 py-2 text-xs uppercase tracking-wide shrink-0 border-b"
         style="color: var(--p-text-muted-color)">
      <div class="col-span-4">Account</div>
      <div class="col-span-3">Orders<span *ngIf="isSortedBy('orderCount')"> &darr;</span></div>
      <div class="col-span-3 text-right">Value<span *ngIf="isSortedBy('openValueAmt')"> &darr;</span></div>
      <div class="col-span-2 text-right">Avg Days<span *ngIf="isSortedBy('avgDaysOverdue')"> &darr;</span></div>
    </div>

    <!-- Ranked Accounts -->
    <div class="flex-1 min-h-0 overflow-y-auto">
      <div *ngFor="let r of rows"
           class="grid grid-cols-12 gap-2 px-3 py-2 items-start border-b"
           [title]="r.unitCount + ' units owed, worst order ' + r.worstDaysOverdue + ' days late'">
        <div class="col-span-4 truncate text-sm">{{ r.accountName }}</div>

        <div class="col-span-3">
          <div class="text-sm">{{ r.orderCount }}</div>
          <div class="mt-1 h-1.5 rounded-full w-full" style="background-color: var(--p-surface-200, #e5e7eb)">
            <div class="h-1.5 rounded-full"
                 [style.width.%]="barPct(r)"
                 style="background-color: var(--p-primary-400, var(--p-primary-color))"></div>
          </div>
        </div>

        <div class="col-span-3 text-right text-sm">{{ r.openValueAmt | currency: 'USD' : 'symbol' : '1.0-0' }}</div>

        <div class="col-span-2 text-right text-sm" [style.color]="daysColor(r)">{{ r.avgDaysOverdue }}d</div>
      </div>

      <div *ngIf="rows.length === 0"
           class="flex items-center justify-center h-full text-sm"
           style="color: var(--p-text-muted-color)">
        No job order is past its promised ship date.
      </div>
    </div>

    <!-- Threshold Legend -->
    <div *ngIf="rows.length > 0"
         class="flex gap-4 items-center px-3 py-2 text-xs shrink-0 border-t"
         style="color: var(--p-text-muted-color)">
      <span class="flex gap-1 items-center">
        <i class="pi pi-circle-fill" style="font-size: 0.6rem; color: var(--p-text-muted-color)"></i>
        Under {{ warnDays }} days
      </span>
      <span class="flex gap-1 items-center">
        <i class="pi pi-circle-fill" style="font-size: 0.6rem; color: var(--p-yellow-500, #eab308)"></i>
        {{ warnDays }} to {{ lateDays - 1 }}.9 days
      </span>
      <span class="flex gap-1 items-center">
        <i class="pi pi-circle-fill" style="font-size: 0.6rem; color: var(--p-red-500, #ef4444)"></i>
        {{ lateDays }}+ days
      </span>
    </div>
  </ng-container>
</div>
